import Dropdown from '../../../../components/Dropdown/Dropdown'
import FontInput from '../../../../components/FontInput/FontInput'
import LetterSpacingInput from '../../../../components/LetterSpacingInput/LetterSpacingInput'
import { useRef } from 'react'
import TextOptions from '../../../../components/TextOptions/TextOptions'
import ColorInput from '../../../../components/ColorInput/ColorInput'

const PlaylistEditModalGeneralTab = ({
  values,
  setValue,
  onSaveClick,
  onSavePublishClick,
  publishLabel,
}) => {
  const ref = useRef()

  const fontFamily = values?.fontFamily || 'Open Sans'
  return (
    <div className="p-6" ref={ref}>
      <h3 className="mb-4">General Settings</h3>

      <h4 className="mb-2">Text and Fonts</h4>
      <div className="mt-4">
        <FontInput
          label="Font Family"
          name="font"
          value={fontFamily}
          onChange={(value) => setValue('fontFamily', value)}
        />
      </div>
      <div className="mt-4">
        <LetterSpacingInput
          value={values.letterSpacing}
          onChange={(value) => setValue('letterSpacing', value)}
        />
      </div>

      <h4 className="mb-2 mt-8">Colors</h4>
      <div className="mt-4">
        <ColorInput
          label="Primary Color"
          tooltip="Used for highlighting currently selected track, volume slider and loop button."
          value={values.primaryColor}
          containerRef={ref}
          onChange={(value) => setValue('primaryColor', value)}
        />
      </div>
      <div className="mt-4">
        <ColorInput
          label="Default Color"
          tooltip="Used for the volume, metadata, loop buttons."
          value={values.secondaryColor}
          containerRef={ref}
          onChange={(value) => setValue('secondaryColor', value)}
        />
      </div>

      <div className="mb-4 mt-8">
        <button
          className="button bg-pink hover:bg-pink-off"
          onClick={onSaveClick}
        >
          Save
        </button>
        <button
          className="button ml-4 text-white-dark"
          onClick={onSavePublishClick}
        >
          {publishLabel}
        </button>
      </div>
    </div>
  )
}

export default PlaylistEditModalGeneralTab
